export function isValidCnpj(cnpj: string): boolean {
    const cleaned = cnpj.replace(/\D/g, '');

    if (cleaned.length !== 14) return false;
    if (/^(\d)\1{13}$/.test(cleaned)) return false;

    const calcDigit = (base: string): number => {
        const weights = base.length === 12
            ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
            : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        let total = 0;
        for (let i = 0; i < base.length; i++) total += Number(base[i]) * weights[i];
        const remainder = total % 11;
        return remainder < 2 ? 0 : 11 - remainder;
    };

    const digit1 = calcDigit(cleaned.slice(0, 12));
    const digit2 = calcDigit(cleaned.slice(0, 12) + digit1);

    return digit1 === Number(cleaned[12]) && digit2 === Number(cleaned[13]);
}
